/*
@deprecated
import from "@similarweb/pro-logic-components"
*/
export default () => {
    return {
        legend: {
            enabled: false,
        },
    };
};
